export default {"src":"/apac/_next/static/media/thermofisher-scientific.e07b0ca0.svg","height":16,"width":134,"blurWidth":0,"blurHeight":0};